import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import "./api/openseadragon2.2.1"
// import "./api/openseadragon-canvas-overlay"
import "./api/openseadragon-paperjs-overlay"
import Paper from "../node_modules/paper/dist/paper-full.js"


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import { Toast } from 'vant';
import { Dialog } from 'vant';

import md5 from 'js-md5';

import 'vant/lib/index.css';



Vue.prototype.md5 = md5;


window.paper = Paper.paper;

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(Toast);
Vue.use(Dialog);


//全局css
import './style/base.scss';

//引入后台接口
import Api from './api/axios.js';
Vue.prototype.ajax = Api;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
